import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgFax(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="6 9 48 42"
      fill="none"
      {...props}
    >
      <path
        fill={props.primaryColor}
        d="M41.194 11c1.664 0 3.066 1.277 3.066 2.905v2.653h.932c.586 0 1.108.451 1.109 1.067v9.884h1.8c2.439 0 4.47 1.868 4.47 4.221V45.02c0 2.354-2.031 4.221-4.47 4.221H12.47C10.03 49.24 8 47.373 8 45.02V31.73c0-2.354 2.031-4.222 4.47-4.222h1.8v-9.884c0-.616.523-1.067 1.109-1.067h.932v-2.653c0-1.628 1.402-2.905 3.066-2.905zM12.47 29.645c-1.267 0-2.251.962-2.251 2.085V45.02c0 1.123.983 2.085 2.25 2.086h1.802V35.314c0-.616.522-1.069 1.108-1.069h29.814c.586 0 1.109.453 1.109 1.069v11.79h1.8c1.268 0 2.252-.962 2.252-2.085V31.73c0-1.124-.985-2.087-2.252-2.087zm4.018 17.46h27.596V36.382H16.487zm2.89-33.968c-.494 0-.848.371-.848.768V27.51h23.513V13.905c0-.397-.355-.768-.848-.768z"
      />
      <path
        fill={props.secondaryColor}
        stroke={props.secondaryColor}
        strokeWidth={0.784}
        d="M24.125 18.276c0 .29.25.525.56.525h11.202c.31 0 .56-.235.56-.525s-.25-.526-.56-.526H24.685a.58.58 0 0 0-.396.154.5.5 0 0 0-.165.372ZM27.485 44.565c0 .29.114.525.255.525h5.092c.14 0 .255-.235.255-.525s-.114-.526-.255-.526H27.74c-.067 0-.132.055-.18.154a.9.9 0 0 0-.075.372ZM20.764 22.482c0 .29.387.526.866.526h17.312c.478 0 .866-.236.866-.526s-.388-.526-.866-.526H21.63c-.23 0-.45.056-.613.154-.162.099-.253.233-.253.372Z"
      />
    </svg>
  );
}
export default SvgFax;
